import * as LightIcons from './lightIcons';
import * as SolidIcons from './solidIcons';
import Icon from './Icon';

const IconList = { solid: SolidIcons, light: LightIcons };

export { Icon, IconList };
